import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../graphql/common.datatypes';
import {Payment} from '../../graphql/payments.datatypes';

export const gqlPaymentAndGroupMemberPayments = `
    id
    timestamp
    amount
    payment_type
    payment_status
    billing_party_member_id
    billing_party_amount
    assignedAmount
    description
    provider_reference
    provider_status
    provider_response_raw
    refunds_amount

    billingPartyMember {
        id
        billing_party_id
        is_group_leader
        first_name
        last_name
        email
    }

    groupMemberPayments {
        id
        group_member_id
        amount
        groupMember {
            first_name
            last_name
        }
    }
`;

interface PaymentsData {
    paymentsInMyGroup: void,
    payments: void,
    paymentsWithGroupMemberPaymentsOfType: {
        data: Payment[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_PAYMENTS_AND_GROUP_MEMBER_PAYMENTS_QUERY = gql`
    query paymentsWithGroupMemberPaymentsOfType($count: Int!, $page: Int!, $billingPartyId: Int!, $paymentType: Int!){
        paymentsWithGroupMemberPaymentsOfType(first: $count, page: $page, billingPartyId: $billingPartyId, paymentType: $paymentType){
            data {
                ${gqlPaymentAndGroupMemberPayments}
            }
            ${gqlPaginatorInfo}
        }
    }
`;

export const getPaymentsAndGroupMemberPayments = (count: number, page: number, billingPartyId: number, paymentType: number) => useQuery<PaymentsData>(
    GET_PAYMENTS_AND_GROUP_MEMBER_PAYMENTS_QUERY,
    {
        variables: {
            count,
            page,
            billingPartyId,
            paymentType
        },
    }
);

export default getPaymentsAndGroupMemberPayments;
